import React from 'react'
import ReactPlayer from 'react-player';
import { useState, useEffect } from 'react';
import { Modal, Input, AutoComplete, Select, Progress, Upload } from 'antd';
import {
  SubHeading,
} from "components/Typography";
import { subjectFilter, fetchAdminChapterFilter, setCheckedVideo, setCheckedQuestion, setCheckedLecture, fetchClasslist, setUploadContent, updateStdList, fetchFilterTopic, updateSetType, fetchLibraryData, setKey, postCreateTopic, updateAdminChapterInfo, updateFilterTopic } from 'actions/digitalLibrary'
import { connect } from 'react-redux'
import { uploadlecturenotes } from 'actions/digitalLibrary';
import YTPlayer from 'components/ytPlayer';
import { Button } from 'components/Button';
import { Notification } from 'services';

// The backend rejects a type='video' post that arrives without a poster image
// ("Video thumbnail is required for video type"). Keep the field name in one
// place so it can be re-pointed if the API ever renames it.
const VIDEO_THUMBNAIL_FIELD = 'videoThumbnail';
const MAX_THUMBNAIL_MB = 2;

// Ids reach this modal in several shapes - subjects_id, subjectId, an AutoComplete
// option's id - and some of those arrive as strings. The /admin-library/content DTO
// validates them with @IsNumber, so normalise here rather than leaving a string to be
// rejected server-side. Anything unparseable becomes null, which the PUBLISH guard
// already treats as "not chosen".
const toId = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

// Pulls the 11-character id out of any of the YouTube link shapes the modal accepts:
// watch?v=, youtu.be/, /embed/, /v/ and /shorts/.
const getYoutubeId = (url) => {
  const raw = String(url || '').trim();
  const lower = raw.toLowerCase();
  if (lower.indexOf('youtube.com') === -1 && lower.indexOf('youtu.be') === -1) return null;
  const vParam = raw.split(/[?&]/).find((part) => part.indexOf('v=') === 0);
  const candidate = vParam
    ? vParam.slice(2)
    : raw.split('?')[0].split('/').filter(Boolean).pop();
  return /^[A-Za-z0-9_-]{11}$/.test(candidate || '') ? candidate : null;
};

// Turns a remote still into a real File, since the API wants the thumbnail as a
// multipart upload rather than a URL. Tries a plain fetch first and falls back to
// drawing the image into a canvas; both need the host to allow cross-origin reads,
// so this resolves null when it cannot, and the admin supplies an image by hand.
const urlToImageFile = (url, filename) =>
  fetch(url)
    .then((res) => (res.ok ? res.blob() : null))
    .then((blob) => (blob ? new File([blob], filename, { type: blob.type || "image/jpeg" }) : null))
    .catch(() => new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || 480;
          canvas.height = img.naturalHeight || 360;
          canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(
            (blob) => resolve(blob ? new File([blob], filename, { type: "image/jpeg" }) : null),
            "image/jpeg",
            0.85
          );
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = url;
    }));

// Grabs a frame out of a directly-linked video file. Cross-origin hosts that do not
// send CORS headers taint the canvas, so this resolves null rather than throwing and
// the admin picks an image by hand instead.
const captureFrameFromVideo = (url) =>
  new Promise((resolve) => {
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.preload = 'metadata';
    let settled = false;
    const finish = (value) => {
      if (settled) return;
      settled = true;
      video.removeAttribute('src');
      resolve(value);
    };
    const timer = setTimeout(() => finish(null), 10000);
    video.onloadeddata = () => {
      video.currentTime = Math.min(1, (video.duration || 1) / 2);
    };
    video.onseeked = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth || 640;
        canvas.height = video.videoHeight || 360;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          clearTimeout(timer);
          finish(blob ? new File([blob], 'video-thumbnail.jpg', { type: 'image/jpeg' }) : null);
        }, 'image/jpeg', 0.8);
      } catch (e) {
        clearTimeout(timer);
        finish(null);
      }
    };
    video.onerror = () => {
      clearTimeout(timer);
      finish(null);
    };
    video.src = url;
  });

function Videouploadmodel({ type,
  uploadlecturenotes,
  ismodelvisible, setmodevisible,
  setmodel,
  subjectFilter,
  subjects,
  selectedStd, selectedSubject, fetchAdminChapterFilter, getChaptersList, setCheckedVideo, setCheckedQuestion, setCheckedLecture,
  fetchClasslist, getStdList, setUploadContent, updateStdList, fetchFilterTopic, updateSetType, selectedChapter, selectedTopic, topicList, contentPage, setTabKey, postCreateTopic,
  updateAdminChapterInfo, updateFilterTopic
}) {


  const [subjectname, setSubjectName] = useState(null)
  const [inputvalue, setinputvalue] = useState('')
  const [chaptersarray, setchapterarray] = useState([...getChaptersList])
  const [chapter, setchapter] = useState('')
  const [classid, setclassid] = useState(null)
  const [subjectid, setsubjectid] = useState(null)
  const [chapterid, setchapterid] = useState(null)
  const [link, setlink] = useState(null)
  const [submitLoader, setSubmitLoader] = useState(false)
  const [searchChapter, setSearchChapter] = useState("")
  const [optionsChapter, setOptionsChapter] = useState([]);
  const [chapterLoader, setChapterLoader] = useState(false)
  const [subjectLoder, setSubjectLoader] = useState(false)
  const [className, setClassName] = useState(null)
  const [topicId, setTopicId] = useState(null)
  const [topicName, setTopicName] = useState(null)
  const [classLoader, setClassLoader] = useState(false)
  const [topicLoader, setTopicLoader] = useState(false)
  let [topicListToShow, setTopicListToShow] = useState([])
  const [createLoader, setCreateLoader] = useState(false)
  const [progress, setProgress] = useState(0);
  const [progressCheck, setProgressCheck] = useState(false)
  const [optionsBatch, setOptionsBatch] = useState([]);
  const [optionsTopic, setOptionsTopic] = useState([]);
  // Poster image sent alongside the link. The API takes it as a multipart file, so a
  // preview on its own is not enough to publish - thumbnailFile has to be set.
  const [thumbnailFile, setThumbnailFile] = useState(null)
  const [thumbnailPreview, setThumbnailPreview] = useState(null)
  const [thumbnailLoading, setThumbnailLoading] = useState(false)
  // Set once the admin picks their own image, so auto-derivation stops overwriting it.
  const [thumbnailPickedByUser, setThumbnailPickedByUser] = useState(false)


  // Remove the YouTube-specific regex
  // let regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

  // Add a URL validation regex instead
  // let regExp = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/;

  // YouTube URL regex
  const youtubeRegExp = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/i;
  // General video URL regex (matches .mp4, .webm, .ogg, etc.)
  const videoRegExp = /\.(mp4|webm|ogg|mov|m4v|avi|wmv|flv|mkv)(\?.*)?$/i;


  const linkedchanged = (e) => {
    setlink(e.target.value)

  }

  const inputchanged = (e) => {

    setinputvalue(e.target.value)
  }
  const searchResult = (query, currentValue) =>
    query.map((item, index) => {
      const name = String(item.name || item.subjects_name || item.subjectname || '').trim();
      const isSelected = name === String(currentValue || '').trim();
      return {
        key: index,
        value: name,
        id: item.id || item.subjects_id || item.subjectId,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: name
      };
    });

  const searchResultBatch = (query, currentValue) =>
    query.map((item, index) => {
      const displayValue = String(`${item.std} - ${item.section}`).trim();
      const isSelected = displayValue === String(currentValue || '').trim();
      return {
        key: index,
        value: displayValue,
        id: item.id,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: displayValue,
        displayValue: displayValue
      };
    });

  const searchResultTopic = (query, currentValue) =>
    query.map((item, index) => {
      const name = String(item.name || '').trim();
      const isSelected = name === String(currentValue || '').trim();
      return {
        key: index,
        value: name,
        id: item.id,
        style: isSelected ? { backgroundColor: '#C6C2FF', fontWeight: '600' } : {},
        label: name,
        displayValue: name
      };
    });

  useEffect(() => {
    subjectFilter('')
  }, [])

  // Derive a poster from the link so the admin is not forced to hunt one down: YouTube
  // publishes a predictable still, and a directly-linked file gets a frame grabbed out
  // of it. Either way the admin can override with their own image below.
  useEffect(() => {
    if (thumbnailPickedByUser) return;
    let cancelled = false;
    const clearThumbnail = () => {
      if (cancelled) return;
      setThumbnailFile(null);
      setThumbnailPreview(null);
      setThumbnailLoading(false);
    };

    if (!link) {
      clearThumbnail();
      return () => { cancelled = true; };
    }

    const ytId = getYoutubeId(link);
    if (ytId) {
      const poster = `https://img.youtube.com/vi/${ytId}/hqdefault.jpg`;
      setThumbnailLoading(true);
      setThumbnailPreview(poster);
      urlToImageFile(poster, `${ytId}.jpg`).then((file) => {
        if (cancelled) return;
        setThumbnailLoading(false);
        // A null file means the poster host refused the cross-origin read. The preview
        // stays up, but publishing is blocked until an image is picked by hand.
        setThumbnailFile(file);
      });
      return () => { cancelled = true; };
    }

    if (link.match(videoRegExp)) {
      setThumbnailLoading(true);
      captureFrameFromVideo(link).then((file) => {
        if (cancelled) return;
        if (!file) {
          clearThumbnail();
          return;
        }
        setThumbnailLoading(false);
        setThumbnailFile(file);
        setThumbnailPreview(URL.createObjectURL(file));
      });
      return () => { cancelled = true; };
    }

    clearThumbnail();
    return () => { cancelled = true; };
  }, [link, thumbnailPickedByUser])

  const handleThumbnailSelect = (file) => {
    if (!String(file?.type || '').startsWith('image/')) {
      Notification.error('error', 'Thumbnail must be an image file');
      return false;
    }
    if (file.size / 1024 / 1024 > MAX_THUMBNAIL_MB) {
      Notification.error('error', `Thumbnail must be smaller than ${MAX_THUMBNAIL_MB} MB`);
      return false;
    }
    setThumbnailPickedByUser(true);
    setThumbnailFile(file);
    setThumbnailPreview(URL.createObjectURL(file));
    return false;
  };

  const resetThumbnail = () => {
    setThumbnailFile(null);
    setThumbnailPreview(null);
    setThumbnailLoading(false);
    setThumbnailPickedByUser(false);
  };

  const [options, setOptions] = useState([]);
  useEffect(() => {
    setOptions(subjects ? [...searchResult(subjects, subjectname)] : []);
  }, [subjects, subjectname])

  useEffect(() => {
    setOptionsChapter(getChaptersList ? [...searchResult(getChaptersList, searchChapter)] : []);
  }, [getChaptersList, searchChapter])

  useEffect(() => {
    setOptionsBatch(getStdList ? [...searchResultBatch(getStdList, className)] : []);
  }, [getStdList, className])

  useEffect(() => {
    let opts = topicListToShow ? [...searchResultTopic(topicListToShow, topicName)] : [];
    if (topicName && opts.length === 0) {
      opts.push({
        value: -1,
        label: <div>Create {topicName}</div>,
        displayValue: topicName
      });
    }
    setOptionsTopic(opts);
  }, [topicListToShow, topicName])

  useEffect(() => {
    if (selectedSubject && Object.keys(selectedSubject).length !== 0) {
      // setsubjectid(selectedSubject.subjects_id)
      // setSubjectName(selectedSubject.subjects_name)
      fetchClasslist(selectedSubject.subjects_id, '')
      setsubjectid(toId(selectedSubject.subjects_id ? selectedSubject.subjects_id : selectedSubject?.subjectId))
      setSubjectName(selectedSubject.subjects_name ? selectedSubject.subjects_name : selectedSubject.subjectname)
    }
    if (selectedStd && Object.keys(selectedStd).length !== 0) {
      console.log("selectedStd32", selectedStd);
      setclassid(selectedStd.std_id ? selectedStd.std_id : selectedStd.classid)
      setClassName(selectedStd.standard ? selectedStd.standard + '-' + selectedStd.std_section : selectedStd?.className)
      // setclassid(selectedStd.std_id)
      // setClassName(selectedStd.standard + '-' + selectedStd.std_section)
    }

    if (selectedChapter && Object.keys(selectedChapter).length != 0) {
      setchapterid(selectedChapter.chapterId ? selectedChapter.chapterId : selectedChapter?.chapterid)
      setchapter(selectedChapter.chapterName)
      setSearchChapter(selectedChapter.chapterName)
    }

    if (selectedTopic && Object.keys(selectedTopic).length != 0) {
      setTopicId(selectedTopic.topicId)
      setTopicName(selectedTopic.topicName)

    }
  }, [])

  useEffect(() => {
    if (topicList?.length != 0) {
      setTopicListToShow(topicList)
    }
    else {
      setTopicListToShow([])
    }
  }, [topicList])

  const handleSearch = (value) => {
    if (!value) {
      setSubjectName('')
      setsubjectid(null)
    }
    else {
      setSubjectName(value)
      setSubjectLoader(true)
    }
    subjectFilter(value, () => setSubjectLoader(false))

  };


  const handleChangeSub = (value, obj) => {
    setsubjectid(null)
    setclassid(null)
    setClassName(null)
    setchapterid(null)
    setSearchChapter('')
    setTopicId(null)
    setTopicName(null)
    updateStdList([])
    if (value) {
      setSubjectName(obj?.label?.props?.children?.props?.children)
    }
  }

  const handleSearchChapter = (value) => {
    setTopicId(null)
    setTopicName(null)
    if (!value) {
      setSearchChapter('')
    }
    else {
      setSearchChapter(value)
      setChapterLoader(true)
    }
    fetchAdminChapterFilter(value, classid, subjectid, () => setChapterLoader(false))

  };

  const handleSearchBatch = (value) => {
    setClassName(value)
    if (!value) {
      setclassid(null)
    }
  }

  const onSelectBatch = (value, obj) => {
    setclassid(obj.id)
    setClassName(value)
    if (obj.id != classid) {
      setChapterLoader(true)
      updateAdminChapterInfo([])
      setchapterid(null)
      setchapter('')
      setSearchChapter('')
      setTopicId(null)
      setTopicName(null)
      updateFilterTopic([])
      fetchAdminChapterFilter('', obj.id, subjectid, () => setChapterLoader(false))
      setchapterarray([...getChaptersList])
    }
  }


  const onSelect = (value, obj) => {
    setSubjectName(value)
    setsubjectid(toId(obj.id))
    fetchClasslist(obj.id, '')
    setclassid(null)
    setClassName(null)
    setchapterid(null)
    setchapter('')
    setSearchChapter('')
    updateStdList([])
    updateAdminChapterInfo([])
  };

  const onSelectChapter = (value, obj) => {
    setTopicId(null)
    setTopicName(null)
    updateFilterTopic([])
    setSearchChapter(value)
    setchapter(value)
    setchapterid(obj.id)
    setTopicLoader(true)
    fetchFilterTopic(subjectid, classid, obj.id, () => setTopicLoader(false))

  };

  const handleChangeChapter = (value, obj) => {
    setchapterid(null)
    setchapter('')
    setSearchChapter('')
    setTopicId(null)
    setTopicName(null)
    updateFilterTopic([])
    if (value) {
      setSearchChapter(value)
      setchapter(value)
    }
  }

  const onSelectTopic = (value, obj) => {
    if (value != -1) {
      setTopicId(obj.id)
      setTopicName(value)
    }
    else if (value == -1) {
      let object = {
        chapterId: chapterid,
        topicName: obj.displayValue
      }
      setTopicName(null)
      postCreateTopic(object, () => setCreateLoader(false), successCallbackTopic)
    }
    else {
      setTopicId(null)
      setTopicName(null)
    }
    fetchFilterTopic(subjectid, classid, chapterid, () => setTopicLoader(false))
  }

  const successCallbackTopic = () => {
    fetchFilterTopic(subjectid, classid, chapterid, () => setTopicLoader(false))
  }

  const handleChangeTopic = (value, obj) => {
    if (value != -1) {
      setTopicId(value)
      setTopicName(obj?.displayValue)
    }
    else if (value == -1) {
      setTopicName(null)
    }
    else {
      setTopicId(null)
      setTopicName(null)
    }
  }

  const handleSearchTopic = (value) => {
    if (value && value.trim() != '') {
      setTopicName(value)
      let topic;
      topic = topicList.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()))
      setTopicListToShow(topic)
      setTopicId(null)
    }
    else {
      setTopicId(null)
      setTopicName(null)
      setTopicListToShow(topicList)
    }
  }

  const successhandler = async () => {
    if (subjectid && chapterid && inputvalue && classid && chapter && link) {
      var objectToUpload = {
        subjectId: subjectid,
        chapterId: parseInt(chapterid),
        title: inputvalue,
        standardId: parseInt(classid),
        type,
        link: link,
        chapterName: chapter,
        topicId: toId(topicId),
      }

      // A video post is rejected server-side unless it carries a poster image, sent as
      // a multipart file alongside the rest of the form.
      if (type == 'video') {
        if (!thumbnailFile) {
          Notification.error('error', 'Please add a video thumbnail before publishing');
          return;
        }
        objectToUpload[VIDEO_THUMBNAIL_FIELD] = thumbnailFile;
      }

      if (type == 'lecture-notes' && contentPage) {
        setTabKey('1')
        updateSetType(type);
      }
      else if (type == 'video' && contentPage) {
        setTabKey('2')
        updateSetType(type);
      }
      else if (type == 'question-bank' && contentPage) {
        setTabKey('3')
        updateSetType(type);
      }
      setProgressCheck(true)
      setSubmitLoader(true)
      uploadlecturenotes(objectToUpload, () => setSubmitLoader(false), successCallback, setProgress)
      if (subjectid && chapterid && inputvalue && classid && chapter && subjectname && className) {
        var selectedUploadObject = {
          subjectId: subjectid,
          subjectname: subjectname,
          classid: parseInt(classid),
          className: className,
          chapterid: parseInt(chapterid),
          chapterName: chapter,
          topicId: parseInt(topicId),
          topicName: topicName,
          title: inputvalue
        }

        setUploadContent(selectedUploadObject)
      }

    }
  }

  const successCallback = () => {
    setlink(null)
    setchapterid(null)
    setlink(null)
    setSearchChapter('')
    setchapter('')
    setinputvalue('')
    setProgressCheck(false)
    setTopicListToShow([])
    resetThumbnail()
    setmodevisible(false)
    setmodel(true)
  }


  const handleCancel = () => {
    setchapterid(null)
    setlink(null)
    setSearchChapter('')
    setchapter('')
    setinputvalue('')
    setTopicListToShow([])
    setProgressCheck(false)
    setCheckedVideo(false)
    setCheckedQuestion(false)
    setCheckedLecture(false)
    resetThumbnail()
    setmodevisible(false);
  };

  return (
    <Modal className='rounded-border' width='60%'
      visible={ismodelvisible} footer={null} closable={!progressCheck}
      onCancel={handleCancel} maskClosable={false}
    >
      <div className='lecturenotestitle' style={{ width: '100%', textAlign: 'center', margin: '0px', padding: '0px' }}>
        <p style={{ margin: '0px' }}> Upload content for digital library</p>
      </div>

      <div className='lecturnotesdescription' style={{ width: '100%', textAlign: 'center' }}>
        <p style={{ margin: '0px', padding: '0px' }}> Kindly attach the file and fill in the informations below</p>
      </div>

      <div style={{ margin: '7%' }}>
        <div style={{ width: '100%' }}>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Video link</p>
              </div>
              <div style={{ marginBottom: '1px', fontSize: '12px', color: '#FF414D', font: 'normal normal bold 12px/16px Roboto' }}>
                {
                  link === null || link === "" || link.match(youtubeRegExp) || link.match(videoRegExp)
                    ? null
                    : (<>Invalid Link</>)
                }
              </div>
            </div>
            <Input onChange={linkedchanged} value={link}></Input>
          </div>
          <p style={{ fontSize: '10px', font: 'normal normal normal 10px/26px Roboto', opacity: '1', color: '#AEAEAE', marginTop: '2%' }}>Example: http://www.websitename.com/watch?v=2Qsg3rQcfIE</p>
        </div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {console.log('linkPath1', link, link?.match(youtubeRegExp),link?.match(videoRegExp))}
          {
            link && link.match(youtubeRegExp) ?
              <YTPlayer keyboardControls={true} videoUrl={link} />
              : link && link.match(videoRegExp) ?
                <ReactPlayer
                  style={{ marginTop: 30 }}
                  height='20%'
                  width='60%'
                  url={link}
                  controls={true}
                />
                : null
          }
        </div>

        {/* The poster is derived from the link, so this row stays out of the way. It only
            surfaces when derivation came back empty - a cross-origin host that blocks the
            read - because PUBLISH is otherwise stuck behind a thumbnail nobody can supply. */}
        {link && !thumbnailLoading && !thumbnailFile ?
          <div style={{ width: '100%', marginTop: '4%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Video thumbnail</p>
              <div style={{ marginBottom: '1px', fontSize: '12px', color: '#FF414D', font: 'normal normal bold 12px/16px Roboto' }}>Thumbnail required</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '6px' }}>
              {thumbnailPreview
                ? <img src={thumbnailPreview} alt='Video thumbnail'
                  onError={() => setThumbnailPreview(null)}
                  style={{ width: 120, height: 68, objectFit: 'cover', borderRadius: 4, border: '1px solid #E6E6E6' }} />
                : <div style={{ width: 120, height: 68, borderRadius: 4, border: '1px dashed #E6E6E6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#AEAEAE' }}>
                  No thumbnail
                </div>}
              <div style={{ marginLeft: 12 }}>
                <Upload accept='image/*' showUploadList={false} beforeUpload={handleThumbnailSelect} disabled={progressCheck}>
                  <Button type='default' disabled={progressCheck}>UPLOAD</Button>
                </Upload>
                <p style={{ fontSize: '10px', color: '#AEAEAE', margin: '4px 0 0 0' }}>
                  {`Could not be taken from the link - please upload an image under ${MAX_THUMBNAIL_MB} MB.`}
                </p>
              </div>
            </div>
          </div>
          : null}

        <div style={{ display: 'flex', marginTop: '10%', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ width: '48%', padding: '2%' }}>
            <div className='generaltwocomponent'>
              <div className='full-width'>
                <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Subject</p>
                <AutoComplete allowClear={subjectname ? true : false}
                  dropdownMatchSelectWidth={252}
                  options={options}
                  onSelect={onSelect}
                  onSearch={handleSearch}
                  onFocus={() => {
                    setTimeout(() => {
                      subjectFilter('')
                    }, 100)
                  }}
                  filterOption={false}
                  onChange={handleChangeSub}
                  value={subjectname}
                  className='autocompletetoupload'
                  loading={subjectLoder}
                  disabled={progressCheck}
                >
                  <Input size="middle"
                    onClick={() => subjectFilter('')}
                    style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%' }}
                    placeholder="Select subject" />
                </AutoComplete>
              </div>
            </div>
            <div className='full-width' style={{ height: '100%' }}>
              <div className='generaltwocomponent' style={{ width: '100%' }}><p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Chapter</p>
                <div style={{ width: '100%' }}>
                  <AutoComplete
                    allowClear={searchChapter ? true : false}
                    dropdownMatchSelectWidth={252}
                    className='autocompletetoupload'
                    disabled={classid && subjectid && !progressCheck ? false : true}
                    options={optionsChapter}
                    value={searchChapter}
                    onChange={handleChangeChapter}
                    onSelect={onSelectChapter}
                    onSearch={handleSearchChapter}
                    loading={chapterLoader}
                  >
                    <Input size="middle" style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%' }} placeholder="Search Chapter" />
                  </AutoComplete>
                </div>
              </div>
            </div>
          </div>
          <div style={{ width: '48%', padding: '2%' }}>
            <div className='generaltwocomponent'>
              <div className='udloadFilesDropdown' >
                <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Batch</p>
                <AutoComplete
                  getPopupContainer={(trigger) => trigger.parentElement}
                  allowClear={className ? true : false}
                  dropdownMatchSelectWidth={252}
                  options={optionsBatch}
                  value={className}
                  onSelect={onSelectBatch}
                  onSearch={handleSearchBatch}
                  filterOption={false}
                  className='autocompletetoupload'
                  loading={classLoader}
                  disabled={subjectid && !progressCheck ? false : true}
                >
                  <Input size="middle"
                    style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%', textAlign: 'left' }}
                    placeholder="Select batch" />
                </AutoComplete>
              </div>
            </div>
            <div className='generaltwocomponent udloadFilesDropdown' style={{ width: '100%' }}>
              <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Topic</p>
              <AutoComplete
                allowClear={topicName ? true : false}
                dropdownMatchSelectWidth={252}
                options={optionsTopic}
                value={topicName}
                onSelect={onSelectTopic}
                onSearch={handleSearchTopic}
                onChange={handleChangeTopic}
                filterOption={false}
                className='autocompletetoupload'
                disabled={chapterid && !progressCheck ? false : true}
                loading={topicLoader}
              >
                <Input size="middle"
                  style={{ background: '#FAFAFA 0% 0% no-repeat padding-box', border: 'none', width: '100%', textAlign: 'left' }}
                  placeholder="Select Topic" />
              </AutoComplete>

            </div>


          </div>
        </div>
        <div style={{ padding: '0 2%' }}>
          <p id='Searchboxtitle' style={{ marginBottom: '1px', fontSize: '12px', color: '#191919', font: 'normal normal bold 12px/16px Roboto' }}>Title</p>
          <div className='uploadfilesinput'>
            <Input size='middle' bordered={false} onChange={inputchanged} value={inputvalue} placeholder='Enter title'
              style={{
                background: '#FAFAFA 0% 0% no-repeat padding-box', borderRadius: '4px',
                opacity: '1'
              }}
              disabled={progressCheck}
            >
            </Input>
          </div>
        </div>
        <div style={{ display: (progressCheck) ? 'inline' : 'none' }}>
          Uploading...
          <Progress type='line' style={{ width: '100%', display: progressCheck ? 'inline' : 'none' }} percent={progress} />
        </div>
        <div style={{ width: '100%', marginTop: '10%' }}>
          <div style={{ width: "100%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <Button style={{ width: "122px", marginRight: "5px", color: '#AEAEAE' }} type="default" onClick={handleCancel}>CANCEL</Button>
            <Button loading={submitLoader} style={{ width: "122px", marginLeft: "5px", }} type="primary" onClick={successhandler} disabled={subjectid && chapterid && inputvalue.trim() != '' && classid && chapter && link && (link.match(youtubeRegExp) || link.match(videoRegExp)) && topicId && (type != 'video' || thumbnailFile) ? false : true}>PUBLISH</Button>
          </div>
        </div>
      </div>

    </Modal>
  )
}

const mapStateToProps = (state) => {
  const {
    subjects,
    selectedStd,
    selectedSubject,
    getChaptersList,
    getStdList,
    topicList,
    selectedChapter, selectedTopic

  } = state.digitalLibrary;
  return {
    subjects,
    selectedStd,
    selectedSubject,
    getChaptersList,
    getStdList,
    topicList,
    selectedChapter, selectedTopic

  };
};

const mapDispatchToProps = (dispatch) => ({
  subjectFilter: (data, callback) => dispatch(subjectFilter(data, callback)),
  uploadlecturenotes: (data, callback, successCallback, setProgress) => dispatch(uploadlecturenotes(data, callback, successCallback, setProgress)),
  fetchAdminChapterFilter: (value, classid, subjectid, callback) => dispatch(fetchAdminChapterFilter(value, classid, subjectid, callback)),
  setCheckedLecture: (bool) => dispatch(setCheckedLecture(bool)),
  setCheckedVideo: (bool) => dispatch(setCheckedVideo(bool)),
  setCheckedQuestion: (bool) => dispatch(setCheckedQuestion(bool)),
  fetchClasslist: (subid, chapterName, callback) => dispatch(fetchClasslist(subid, chapterName, callback)),
  setUploadContent: (object) => dispatch(setUploadContent(object)),
  updateStdList: (std) => dispatch(updateStdList(std)),
  fetchFilterTopic: (subId, stdId, chapterId, callback) => dispatch(fetchFilterTopic(subId, stdId, chapterId, callback)),
  updateSetType: (type) => dispatch(updateSetType(type)),
  fetchLibraryData: (search, callback) => dispatch(fetchLibraryData(search, callback)),
  setKey: (key) => dispatch(setKey(key)),
  postCreateTopic: (object, callback, successCallback) => dispatch(postCreateTopic(object, callback, successCallback)),
  updateAdminChapterInfo: (data) => dispatch(updateAdminChapterInfo(data)),
  updateFilterTopic: (data) => dispatch(updateFilterTopic(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Videouploadmodel)